import { Box, Container, Stack, Typography } from '@mui/material';
import { ApiStatus } from './components/ApiStatus';

export default function App() {
  return (
    <Container maxWidth="md">
      <Box sx={{ py: 8 }}>
        <Stack spacing={4}>
          <Box>
            <Typography variant="h3" component="h1" gutterBottom>
              docent
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Scaffolded and connected. Replace this page with the actual product.
            </Typography>
          </Box>

          <ApiStatus />

          <Typography variant="body2" color="text.secondary">
            Add endpoints in <code>backend/app/routes.py</code>, run{' '}
            <code>make types</code>, and call them from{' '}
            <code>frontend/src/api/client.ts</code> with full type safety.
          </Typography>
        </Stack>
      </Box>
    </Container>
  );
}
